import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import './i18n'
import App from './App'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Authenticator } from '@aws-amplify/ui-react'
import { NotificationContextProvider } from './context/Shared/Notification.context'

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0
  })
}

const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) {
    return
  }

  try {
    await navigator.serviceWorker.register('/service-worker.js', {
      updateViaCache: 'none'
    })
  } catch (error) {
    console.error('Service worker registration failed:', error)
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    registerServiceWorker()
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <Authenticator.Provider>
    <NotificationContextProvider>
      <App />
    </NotificationContextProvider>
  </Authenticator.Provider>
)
